import { useRef, useEffect } from "react";

interface Props {
  src: string;
  aspectRatio: "16/9" | "9/16";
}

export default function VideoPlayer({ src, aspectRatio }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [src]);

  const containerClass =
    aspectRatio === "16/9"
      ? "aspect-video max-w-4xl"
      : "aspect-[9/16] max-w-sm";

  return (
    <div className={`${containerClass} mx-auto bg-black rounded-lg overflow-hidden`}>
      <video
        ref={videoRef}
        className="w-full h-full"
        controls
        playsInline
        preload="metadata"
      >
        <source src={src} type="video/mp4" />
        Your browser does not support video playback.
      </video>
    </div>
  );
}
